import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { TripService } from './../models/trip.service';
import { TripOverviewList } from './../models/trip-overviewlist.model';
import { WeGoConfig, IAPIResponse, DataListModel, ApplicationRouteURL } from '../../shared/config';

const moment = require("moment");

@Component({
  selector: 'wego-trip-history',
  template: require('../views/trip-history.component.html'),
  providers: [TripService],
})
export class TripHistoryComponent implements OnInit {

  apiErrorMsg: string;
  DataListModel: DataListModel;
  errorModel: IKeyValueInterface[];
  readMore: IKeyValueInterface[];
  tripList: TripOverviewList[];
  isLoading: boolean;
  message: string;
  model: TripOverviewList = new TripOverviewList();
  urlDefaultPage: string;
  urlDriverTripInformation: string;

  constructor(private authService: AuthService,
    private tripService: TripService,
    private router: Router, private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlDriverTripInformation = this.authService.GetURL(ApplicationRouteURL.URL_TRIP_INFORMATION_DRIVER);
    this.GetTripHistory();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetTripHistory();
  }

  private GetTripHistory() {
    this.isLoading = true;
    this.tripService
      .GetTripHistoryList(this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.tripList = res.data;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetTripHistory();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetTripHistory();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trip/components/trip-history.component.ts